import React, { createContext, useContext, useEffect, useState } from "react";
import { api, mediaUrl } from "@/lib/api";

/**
 * Every headline, paragraph and hero image on the site comes from here, so the
 * owner can change the wording in Admin → Site Content without a code change.
 * The component's own string is the fallback until the API answers.
 */
const ContentContext = createContext({ content: null, ready: false });

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    api.get("/content").then(({ data }) => setContent(data)).catch(() => setContent({}));
  }, []);

  return (
    <ContentContext.Provider value={{ content, ready: content !== null }}>
      {children}
    </ContentContext.Provider>
  );
};

export function useContent() {
  const { content, ready } = useContext(ContentContext);
  /** `c("home.hero.title", "fallback")` */
  const c = (path, fallback = "") => {
    const value = path.split(".").reduce((node, key) => (node == null ? node : node[key]), content);
    return value === undefined || value === null || value === "" ? fallback : value;
  };
  /** Same, resolved for <img src>. Undefined when unset, so React never sees src="". */
  const img = (path, fallback = "") => mediaUrl(c(path, fallback)) || undefined;
  return { c, img, ready, content };
}

export default ContentProvider;
